module.exports = __webpack_public_path__ + "img/Shield Shattered.a37db76f.png";